(()=>{
  const section = document.currentScript.closest('section');

  const stickyButton = section.querySelector('.landing-builder__sticky-button');
  const stickyButtonLink = stickyButton?.querySelector('a')
  const targetSection = document.querySelector(stickyButtonLink?.getAttribute('href'))

  if(!stickyButton || !targetSection) return

  const callback = (entries) => {
    entries.forEach((entry) => {
        stickyButton.classList.toggle('hidden', entry.isIntersecting);
    })
  }


  const observer = new IntersectionObserver(callback, {
    threshold: 0,
    rootMargin: '0px 0px -10% 0px'
  })

  observer.observe(targetSection)

  const anchors = document.querySelectorAll('a[href^="#"]');

  if(window.innerWidth > 750) return

  anchors.forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const targetElement = document.querySelector(`${anchor.getAttribute('href')} .product-form__submit`);
      e.preventDefault();
      
      if(!targetElement) return;

      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    });
  })
})()